import React, { Fragment } from 'react';
import { NavLink as RouterLink } from 'react-router-dom';

import {
  Box,
  Grid,
  Card,
  CardContent,
  colors,
  Icon,
  Typography,
  Button,
  makeStyles
} from '@material-ui/core';

import { BsPinAngleFill } from "react-icons/bs";
import { RiAlarmWarningLine } from "react-icons/ri";
import { Activity } from 'react-feather';
import { MdManageAccounts } from "react-icons/md";
import { MdEngineering } from "react-icons/md";
import { RiArchiveLine } from "react-icons/ri";
import { GiHandTruck } from "react-icons/gi";
import { AiOutlineSchedule } from "react-icons/ai";
import { MdWaterfallChart } from "react-icons/md";

const items = [
  {
    href: '/sup/supports',
    icon: RiAlarmWarningLine,
    title: 'Ocorrências',
    color: colors.orange[500],
    profile: 'AST'
  },
  {
    href: '/sup/launching',
    icon: RiArchiveLine,
    title: 'Caixinha',
    color: colors.orange[500],
    profile: 'AST'
  },
  {
    href: '/sup/trackings',
    icon: BsPinAngleFill,
    title: 'Rastreamento',
    color: colors.orange[500],
    profile: 'AAD'
  },
  {
    href: '/mon/main',
    icon: Activity,
    title: 'Monitoramento',
    color: colors.teal['A400'],
    profile: 'AAD'
  },
  {
    href: '/mgt/main',
    icon: MdEngineering,
    title: 'Manutenção',
    color: colors.cyan[400],
    profile: 'AAD'
  },
  {
    href: '/sup/supports',
    icon: RiAlarmWarningLine,
    title: 'Ocorrências',
    color: colors.orange[500],
    profile: 'ADM'
  },
  {
    href: '/sup/trackings',
    icon: BsPinAngleFill,
    title: 'Rastreamento',
    color: colors.orange[500],
    profile: 'ADM'
  },
  {
    href: '/sup/agendas',
    icon: AiOutlineSchedule,
    title: 'Agenda',
    color: colors.orange[500],
    profile: 'ADM'
  },
  {
    href: '/sup/timeline',
    icon: MdWaterfallChart,
    title: 'Cronograma',
    color: colors.orange[500],
    profile: 'ADM'
  },
  {
    href: '/sup/partitions',
    icon: GiHandTruck,
    title: 'Estoque',
    color: colors.orange[500],
    profile: 'ADM'
  },
  {
    href: '/sup/launching',
    icon: RiArchiveLine,
    title: 'Caixinha',
    color: colors.orange[500],
    profile: 'ADM'
  },
  {
    href: '/mon/main',
    icon: Activity,
    title: 'Monitoramento',
    color: colors.teal['A400'],
    profile: 'ADM'
  },
  {
    href: '/mgt/main',
    icon: MdEngineering,
    title: 'Manutenção',
    color: colors.cyan[400],
    profile: 'ADM'
  },
  {
    href: '/adm/main',
    icon: MdManageAccounts,
    title: 'Administração',
    color: colors.blue[400],
    profile: 'ADM'
  },
  {
    href: '/sup/supports',
    icon: RiAlarmWarningLine,
    title: 'Ocorrências',
    color: colors.orange[500],
    profile: 'ENG'
  },
  {
    href: '/sup/trackings',
    icon: BsPinAngleFill,
    title: 'Rastreamento',
    color: colors.orange[500],
    profile: 'ENG'
  },
  {
    href: '/sup/agendas',
    icon: AiOutlineSchedule,
    title: 'Agenda',
    color: colors.orange[500],
    profile: 'ENG'
  },
  {
    href: '/sup/timeline',
    icon: MdWaterfallChart,
    title: 'Cronograma',
    color: colors.orange[500],
    profile: 'ENG'
  },
  {
    href: '/sup/partitions',
    icon: GiHandTruck,
    title: 'Estoque',
    color: colors.orange[500],
    profile: 'ENG'
  },
  {
    href: '/sup/launching',
    icon: RiArchiveLine,
    title: 'Caixinha',
    color: colors.orange[500],
    profile: 'ENG'
  },
  {
    href: '/mon/main',
    icon: Activity,
    title: 'Monitoramento',
    color: colors.teal['A400'],
    profile: 'ENG'
  },
  {
    href: '/mgt/main',
    icon: MdEngineering,
    title: 'Manutenção',
    color: colors.cyan[400],
    profile: 'ENG'
  },
  {
    href: '/adm/main',
    icon: MdManageAccounts,
    title: 'Administração',
    color: colors.blue[400],
    profile: 'ENG'
  },
];


const useStyles = makeStyles((theme) => ({
  root: {},
  avatar: {
    width: 120,
    height: 120
  },
  grid: {
    marginTop: 10
  },
  card: {
    height: 200,
    minWidth: 200
  },
  button: {
    fontWeight: theme.typography.fontWeightMedium,
    textTransform: 'none',
    width: '100%'
  }
}));

const Results = ({ className }) => {

  const classes = useStyles();

  return (
    <Fragment>
      <Box>
        <Grid container
          className={classes.grid}
          spacing={2}
          direction="row"
          justifyContent={(screen.width <= 480) ? "center" : "flex-start"}
        >

          {items.map((value) => (

            <Grid item key={value.href} hidden={localStorage.getItem('profile') != value.profile}  >

              <Button
                className={classes.button}
                component={RouterLink}
                to={value.href}
              >

                <Card className={classes.card}>

                  <CardContent>

                    <Box alignItems="center"
                      display="flex"
                      flexDirection="column"
                    >

                      {<Icon className={classes.avatar} component={value.icon} style={{ color: value.color }} ></Icon>}

                      <Typography align="center"
                        color="primary"
                        gutterBottom
                        variant="h4"
                      >
                        {value.title}
                      </Typography>
                    </Box>

                  </CardContent>

                </Card>

              </Button>

            </Grid>

          ))}

        </Grid>

      </Box>

    </Fragment >
  );
};

export default Results;